import {
  Component,
  OnInit,
  Input,
  AfterViewChecked,
  SimpleChanges,
  OnChanges,
} from '@angular/core'
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  UntypedFormControl,
  Validators,
} from '@angular/forms'
import { DialogAddCartComponent } from '../dialog-add-cart/dialog-add-cart.component'
import { MatDialogRef } from '@angular/material/dialog'
import { CartService } from '../../../services/cart.service'
import {
  IProductListing,
  MarketService,
} from '../../../services/market.service'
import { TranslateService } from '@ngx-translate/core'
import { PaymentService } from '../../../services/payment.service'
import { take } from 'rxjs/operators'
import { SnackbarService } from '../../../services/snackbar.service'
import { User } from '../../../models/user.model'
import { AuthenticationService } from '../../../services/authentication.service'
import { ProductService } from '../../../services/product.service'
import { Router } from '@angular/router'

@Component({
  selector: 'app-add-cart',
  templateUrl: './add-cart.component.html',
  styleUrls: ['./add-cart.component.scss'],
})
export class AddCartComponent implements OnInit, AfterViewChecked, OnChanges {
  addCartForm: UntypedFormGroup
  languageLocale: string
  updateSchedule: any
  available: any
  added = false
  currentUser: User
  price: number
  discountedPrice: number
  discount: number
  priceText: string
  discountedPriceText: string

  calcPrice: number
  calcDiscount: number
  calcDiscountedPrice: number
  calcPriceText: string

  @Input() product: IProductListing
  @Input() availability?: any
  @Input() dialogRef: MatDialogRef<DialogAddCartComponent>

  constructor(
    private fb: UntypedFormBuilder,
    private cart: CartService,
    private router: Router,
    private translate: TranslateService,
    private payment: PaymentService,
    private snackbarService: SnackbarService,
    private authService: AuthenticationService,
    public productService: ProductService,
    private market: MarketService
  ) {
    this.addCartForm = fb.group({
      quantity: new UntypedFormControl(1, [Validators.required]),
    })
    this.authService.userData.subscribe((user) => (this.currentUser = user))
  }

  ngOnInit() {
    this.initPriceInfo()
  }

  initPriceInfo() {
    this.productService.getPriceInformation(this.product).subscribe((price) => {
      this.calcPrice = price.price
      this.calcDiscount = price.discount
      this.calcDiscountedPrice = price.discountedPrice
      this.calcPriceText = price.priceText
    })
  }

  // initialize quantity after product @input values are loaded
  // without afterViewChecked, vendor and discount are loaded without quantity being set
  // thus making the app-advantage @input undefined

  ngAfterViewChecked() {
    this.product.quantity = this.addCartForm.value.quantity
    this.updatePriceInformation()
  }

  // @input product change, reinitialize availability for that product
  ngOnChanges(changes: SimpleChanges) {
    if (changes['product']) {
      this.initPriceInfo()
      if (!this.availability) {
        this.payment
          .getAvailability(this.product.id)
          .pipe(take(1))
          .subscribe(
            (result) => {
              this.available = result
            },
            (err) => {
              this.snackbarService.showSnackbar(
                'error.error_retrieving',
                'error.button.close',
                'error-snack'
              )
            }
          )
      }
    }
    if (changes['availability']) {
      this.available = this.availability
    }
  }

  onFormSubmit() {
    this.cart.add({
      available: this.available,
      name: this.product.name,
      id: this.product.id,
      vendor_price: this.product.vendor_price,
      customPrice: this.product.customPrice,
      price: this.product.price,
      quantity: this.addCartForm.value.quantity,
      discount: this.product.discount,
    })

    this.added = true
    setTimeout(() => {
      this.router.navigate([this.translate.currentLang, 'cart'])
    }, 500)
  }

  changeValue(value: string) {
    this.addCartForm.setValue({
      quantity: Math.max(
        this.addCartForm.value.quantity + (value === 'inc' ? 1 : -1),
        1
      ),
    })
    // this is set so the advantage component can get the update
    this.product.quantity = this.addCartForm.value.quantity
    this.updatePriceInformation()
  }

  updatePriceInformation() {
    this.productService
      .getPriceInformation(this.product)
      .subscribe((prices) => {
        this.price = prices.price
        this.discount = prices.discount
        this.discountedPrice = prices.discountedPrice
        this.priceText = prices.priceText
        this.discountedPriceText = prices.discountedPriceText
      })
  }
}
